import React from 'react';
import { Box, Grid, SelectChangeEvent, Typography } from '@mui/material';
import {
  addElementIdToRecipient,
  removeElementIdFromRecipients,
  selectRecipients,
  selectedElement,
  updateContentElementById,
} from '../../../../../../../../features/document/documentSlice';
import { isDateElement } from '../../../../../../../../utils/typeGuards';
import RecipientSelect from 'components/RecipientSelect/RecipientSelect';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { colorPalette } from 'styles/partials/colors';

interface DateSidebarProps {
  currentElement: selectedElement;
}

export default function DateSidebar({ currentElement }: DateSidebarProps) {
  if (!isDateElement(currentElement.data)) {
    return null;
  }

  const dispatch = useAppDispatch();
  const {
    data: { recipient: currentRecipient },
  } = currentElement;

  const recipients = useAppSelector(selectRecipients);

  const handleOnChangeRecipient = (event: SelectChangeEvent) => {
    dispatch(removeElementIdFromRecipients(currentElement.data.id));

    const selectedRecipient = recipients.find(recipient => recipient.fullName === event.target.value);
    if (selectedRecipient) {
      dispatch(addElementIdToRecipient({ recipientId: selectedRecipient.id, elementId: currentElement.data.id }));

      dispatch(
        updateContentElementById({
          content: {},
          style: {},
          recipient: selectedRecipient,
        })
      );
    }
  };

  return (
    <Grid container direction='row' className='container' gap={2}>
      <Grid item xs={12}>
        <Typography color={colorPalette.darkGray1} fontSize={'16px'} fontWeight={500} marginBottom={'32px'}>
          Date Block
        </Typography>
        <Box display={'flex'} flexDirection={'column'} gap={'24px'} marginBottom={'24px'}>
          <Typography color={colorPalette.darkGray1} fontSize={'14px'} fontWeight={500}>
            Recipient
          </Typography>
          <RecipientSelect
            value={currentRecipient}
            recipientOptions={recipients}
            editRecipients={false}
            onChange={handleOnChangeRecipient}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
